import { useCallback, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { zodResolver } from '@hookform/resolvers/zod'

import { useHttpClient } from '@/modules/shared/hooks/use-http-client'
import { authForgetPasswordService } from '../services/auth-forget-password.service'
import { useLoginStore } from '../stores/login.store'
import {
  type AuthForgetPasswordSchema,
  authForgetPasswordSchema,
} from '../schemas/auth-forget-password.schema'

export function useAuthForgetPassword() {
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const navigate = useNavigate()
  const { email, companySelected } = useLoginStore()


  const form = useForm<AuthForgetPasswordSchema>({
    resolver: zodResolver(authForgetPasswordSchema),
    defaultValues: {
      email: email || '',
    },
  })

  const httpClient = useHttpClient(
    authForgetPasswordService,
    {
      onSuccess: (response) => {
        if (response.status === 200) {
          intervalRef.current = setTimeout(() => {
            navigate('/login')
          }, 2000)
        }
      },
      showToast: true,
    }
  )

  const submitAuthForgetPassword = useCallback((data: AuthForgetPasswordSchema) => {
    httpClient.execute({ payload: {
			email: data.email,
			company: companySelected || '',
		} })
  }, [httpClient])

  // Atualizar email quando disponível no store
  useEffect(() => {
    if (email && email !== form.getValues('email')) {
      form.setValue('email', email)
    }
  }, [email, form])

  // Cleanup do timeout
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearTimeout(intervalRef.current)
      }
    }
  }, [])

  return {
    form,
    isLoading: httpClient.isLoading,
    error: httpClient.error,
    submitAuthForgetPassword,
  }
}